import { format, parseISO } from "date-fns";
import { Organization } from "./userTypes";

export interface InvoiceLineItem {
  id: number;
  sku: string;
  itemDescription: string;
  quantity: number | undefined;
  details?: string | undefined;
  days?: string | undefined;
  usageGB?: number | undefined;
}

export interface InvoiceData {
  items: InvoiceLineItem[] | null;
  organization: Organization | null;
}

export interface CreateInvoiceInZohoResponse {
  data: {
    priceBookId: string;
    invoiceNumber: string;
    customerId: string;
    invoiceId: string;
    status: string;
  };
}

export const getMonthYearFromBillingPeriod = (billingPeriod: string | undefined): string | null => {
  if (!billingPeriod) return null;
  const month = format(parseISO(billingPeriod), 'yyyy-MM');
  return month;
};